import {
	UPDATE_OAT_FORM_PREF_REQUEST,
	UPDATE_OAT_FORM_PREF_SUCCESS,
	UPDATE_OAT_FORM_PREF_FAILURE
} from "../../constants"

import {
	hideClinictModal,
	hideDoctorListModal
} from "../../../assets/js/custome"

import { pharmacy_oat_form_pref_update } from "../../../networking/urlEndPoints"

import Axios from "../../../networking/intraceptor"

export const updateOatPrefRequest = () => ({
	type: UPDATE_OAT_FORM_PREF_REQUEST,
})

export const updateOatPrefSuccess = (data) => ({
	type: UPDATE_OAT_FORM_PREF_SUCCESS,
	payload: data,
})

export const updateOatPrefFailure = (error) => ({
	type: UPDATE_OAT_FORM_PREF_FAILURE,
	payload: error,
})

export const updateOatPref = (requesttype,
	patient_id,
	selectedOptions,
	defaultId,
	showModal,
	setShowModal,) => {
	return async (dispatch) => {
		dispatch(updateOatPrefRequest())
		try {
			const response = await Axios.post(`${pharmacy_oat_form_pref_update}`, {
				requesttype: requesttype,
				patient_id: patient_id,
				prescriber_clinic_id: selectedOptions,
				set_default: defaultId
			})
			if (response?.status === 200) {
				dispatch(updateOatPrefSuccess(response?.data))


				if (requesttype === 'singledoctor') {
					setTimeout(() => {
						hideDoctorListModal(setShowModal, showModal)
					}, 2000)
				}

				if (requesttype === 'singleclinic') {
					setTimeout(() => {
						hideClinictModal(setShowModal, showModal)
					}, 2000)
				}

			} else {
				throw new Error(response)
			}
		} catch (error) {
			if (error?.response) {
				dispatch(updateOatPrefFailure(error?.response))
			}
		}
	}
}
